/* ==========================================================================
   ANIME CRUSH — HOMEPAGE HERO FILM   (owner request 2026-11-03)

   Plays the Anime Crush film muted and looped behind the hero. The still in the
   markup stays the LCP element and the poster: the iframe is added only after
   window load (and an idle moment), so it never competes with the first paint,
   and it is faded in only once YouTube reports it is playing, so a reader never
   sees YouTube's black box or title card. Skipped entirely under
   prefers-reduced-motion and Save-Data; the still is the whole hero then.
   ========================================================================== */
(function () {
  'use strict';

  var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-ac-hero-video]'));
  if (!boxes.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var save = navigator.connection && navigator.connection.saveData;
  if (reduce || save) return;

  function mount(box) {
    var id = box.getAttribute('data-ac-hero-video');
    if (!id || !/^[A-Za-z0-9_-]{6,20}$/.test(id) || box.querySelector('iframe')) return;
    var src = 'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&mute=1&loop=1&playlist=' + id +
      '&controls=0&playsinline=1&rel=0&modestbranding=1&disablekb=1&iv_load_policy=3&fs=0&enablejsapi=1' +
      '&origin=' + encodeURIComponent(location.origin);
    var f = document.createElement('iframe');
    f.src = src;
    f.title = 'Anime Crush film (background, muted)';
    f.setAttribute('tabindex', '-1');
    f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    box.appendChild(f);

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      box.classList.add('is-playing');
    }

    /* YouTube's player posts its state to the parent once we say we are
       listening. State 1 = playing. */
    window.addEventListener('message', function (e) {
      if (e.source !== f.contentWindow) return;
      if (!/youtube(-nocookie)?\.com$/.test((e.origin || '').replace(/^https?:\/\//, ''))) return;
      var d = e.data;
      if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
      if (!d) return;
      var state = d.info && typeof d.info === 'object' ? d.info.playerState : (d.event === 'onStateChange' ? d.info : undefined);
      if (state === 1) setTimeout(show, 400);
    });
    f.addEventListener('load', function () {
      try {
        f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 'ac-film-' + id }), '*');
      } catch (x) {}
      /* if the state message never comes, show it anyway after the title card */
      setTimeout(show, 3500);
    });
  }

  /* the hero film mounts once the page has loaded; a film further down mounts when it
     comes near the screen, so it costs nothing to a reader who never scrolls to it */
  function start() {
    boxes.forEach(function (box, i) {
      if (i === 0 || !('IntersectionObserver' in window)) { mount(box); return; }
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { io.disconnect(); mount(box); }
      }, { rootMargin: '600px 0px' });
      io.observe(box);
    });
  }
  function later() {
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 });
    else setTimeout(start, 800);
  }

  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later);
})();
